import { motion } from "framer-motion";
import { Award, Building2, Users, Globe2, Trophy } from "lucide-react";

const items = [
  {
    year: "2014 — 2015",
    icon: Trophy,
    title: "Youth Technopreneur MarkPlus",
    desc: "Diakui sebagai technopreneur muda yang aktif membangun inovasi digital di tingkat nasional.",
    chip: "Award",
  },
  {
    year: "Penghargaan",
    icon: Award,
    title: "Pelopor Ekosistem Digital Palembang",
    desc: "Mendapat penghargaan dari Wali Kota Palembang sebagai pelopor ekosistem digital kota Palembang.",
    chip: "Recognition",
  },
  {
    year: "Founder",
    icon: Users,
    title: "Chairman & Pendiri Palembang Digital",
    desc: "Mendirikan komunitas Palembang Digital untuk mendukung pertumbuhan ekosistem teknologi lokal.",
    chip: "Community",
  },
  {
    year: "Nationwide",
    icon: Globe2,
    title: "Nationwide Digital System",
    desc: "Terlibat dalam sistem digital yang digunakan di seluruh Indonesia dan melayani lebih dari 5 juta pengguna.",
    chip: "Scale",
  },
];

const Achievement = () => {
  return (
    <section id="achievement" data-testid="achievement-section" className="relative py-24 lg:py-32 overflow-hidden">
      <div className="absolute inset-0 grid-bg-fine opacity-25 pointer-events-none" />
      <div className="absolute top-1/2 -translate-y-1/2 left-0 w-96 h-96 bg-violet-500/10 rounded-full blur-[140px] pointer-events-none" />
      <div className="absolute top-1/3 right-0 w-96 h-96 bg-cyan-500/10 rounded-full blur-[140px] pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] text-blue-400 font-mono-display">
            <span className="w-6 h-px bg-blue-400" />
            /// Achievement & Impact
          </div>
          <h2
            className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-white"
            style={{ fontFamily: "Outfit" }}
            data-testid="achievement-title"
          >
            Pencapaian dan kontribusi dalam{" "}
            <span className="text-gradient-aurora">ekosistem digital.</span>
          </h2>
          <p className="mt-5 text-base text-slate-400 leading-relaxed">
            Pengalaman Joneten Saputra tidak hanya pada pengembangan teknologi, tetapi juga pada
            pembangunan komunitas, ekosistem digital, dan solusi berskala besar.
          </p>
        </div>

        {/* Timeline */}
        <div className="mt-16 relative">
          <div className="hidden lg:block absolute left-1/2 top-0 bottom-0 -translate-x-1/2 w-px bg-gradient-to-b from-transparent via-blue-400/30 to-transparent" />

          <div className="space-y-5 lg:space-y-14">
            {items.map((it, idx) => {
              const Icon = it.icon;
              const isLeft = idx % 2 === 0;
              return (
                <motion.div
                  key={idx}
                  data-testid={`achievement-item-${idx}`}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.55, delay: idx * 0.08 }}
                  className={`relative lg:grid lg:grid-cols-2 lg:gap-12 items-center ${isLeft ? "" : "lg:[direction:rtl]"}`}
                >
                  <div className={`${isLeft ? "" : "lg:[direction:ltr]"}`}>
                    <div className="group rounded-2xl p-7 glass-elevated corners scanline-hover hover:border-blue-400/40 transition-all duration-300 relative overflow-hidden">
                      <div className="absolute top-3 right-3 text-[10px] uppercase tracking-[0.22em] text-blue-400 font-mono-display px-2 py-0.5 rounded-full bg-blue-500/10 border border-blue-400/20">
                        {it.chip}
                      </div>
                      <div className="flex items-center gap-3 mb-4">
                        <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-blue-500/20 to-indigo-500/10 border border-blue-400/30 grid place-items-center group-hover:shadow-[0_0_28px_rgba(59,130,246,0.35)] transition-shadow">
                          <Icon className="w-5 h-5 text-blue-200" strokeWidth={1.5} />
                        </div>
                        <span className="text-[11px] uppercase tracking-[0.22em] text-slate-400 font-mono-display">
                          {it.year}
                        </span>
                      </div>
                      <h3 className="text-xl text-white font-medium" style={{ fontFamily: "Outfit" }}>
                        {it.title}
                      </h3>
                      <p className="mt-2.5 text-sm text-slate-400 leading-relaxed">{it.desc}</p>
                    </div>
                  </div>

                  {/* center node */}
                  <div className="hidden lg:flex absolute left-1/2 -translate-x-1/2 items-center justify-center">
                    <span className="relative w-4 h-4 rounded-full grid place-items-center">
                      <span className="absolute inset-0 rounded-full bg-blue-400/40 blur animate-pulse-soft" />
                      <span className="relative w-2.5 h-2.5 rounded-full bg-blue-400 ring-2 ring-[#060a1a]" />
                    </span>
                  </div>

                  <div className="hidden lg:block" />
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Achievement;
